<template>
  <div class="wrapper-x-40">
    <AdminStickyHeader>
      <template #title>
        {{$t('admin.views.materials.edit')}}
      </template>
    </AdminStickyHeader>
    <Form :material="material" />
  </div>
</template>

<script>
import Form from "./Form";
import AdminStickyHeader from "../../../components/Admin/StickyHeader.vue";
export default {
  name: "Edit",
  components: { AdminStickyHeader, Form },
  props: {
    material: {
      type: Object,
      require: true,
    },
  },
};
</script>
